module.exports = __webpack_public_path__ + "img/61VaoHj7IbL._SX425_.57ec5e93.jpg";